import {
  type Appointment,
  type ConfirmModalDefinition,
  type ConsentModalDefinition,
  type CustomerModalDefinition,
  type CustomerProfileModalDefinition,
  type NewProjectModalDefinition,
  type SelectCoworkerAndTeamModalDefinition,
  type SelectDepartmentModalDefinition,
  type Task,
  clearCustomerData,
  type hfb,
} from "@repo/api";
import { t } from "@repo/translation";
import { logError, trackAnalytics } from "@repo/utils";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useToast } from "../../../components/Toast";
import { useSettings } from "../../../settings/SettingsProvider";
import { getCustomerDetails } from "./utils";

export const CustomerProfile = ({
  pushModal,
  onSelectProject,
  onProjectCreated,
  initialCustomerSearchValue,
  associatedDropInAppointment,
  associatedTask,
  departments,
}: {
  pushModal: (
    modalProps:
      | SelectDepartmentModalDefinition
      | SelectCoworkerAndTeamModalDefinition
      | ConsentModalDefinition
      | CustomerModalDefinition
      | ConfirmModalDefinition
      | CustomerProfileModalDefinition
      | NewProjectModalDefinition,
    reset?: boolean
  ) => void;
  onSelectProject?: (projectId: number) => void;
  onProjectCreated?: (projectId: number) => void;
  initialCustomerSearchValue?: string;
  associatedDropInAppointment?: Appointment;
  associatedTask?: Task;
  departments?: hfb[];
}) => {
  const { updateToast } = useToast();
  const { market, language } = useSettings();
  const navigate = useNavigate();

  useEffect(() => {
    getCustomerProfileModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCustomerProfileModal = () => {
    try {
      const openCustomerProfileModal =
        window.salja?.customerProfile?.openCustomerProfileModal;

      if (openCustomerProfileModal) {
        openCustomerProfileModal({
          onSelectCustomer: () => handleSelectedCustomer(),
        });
      } else {
        updateToast({
          title: t("prompt.customer_profile_not_available"),
          type: "error",
        });
      }
    } catch (error) {
      logError(error);
    }
  };

  const handleSelectedCustomer = async () => {
    try {
      const customerInfo = await getCustomerDetails(market, language);

      if (customerInfo) {
        pushModal(
          {
            type: "NEW_PROJECT",
            customerInfo,
            onProjectCreated:
              onProjectCreated ??
              ((projectId) => {
                navigate(`/opportunity/${projectId}/`);
                clearCustomerData();
                trackAnalytics("new_project_created");
              }),
            onSelectProject:
              onSelectProject ??
              ((projectId) => {
                navigate(`/opportunity/${projectId}/`);
                clearCustomerData();
                trackAnalytics("manage_project");
              }),
            initialCustomerSearchValue,
            associatedDropInAppointment,
            associatedTask,
            departments,
            pushModal,
          },
          true
        );
      } else {
        // eslint-disable-next-line no-console
        console.error("Customer information is undefined");
      }
    } catch (error) {
      logError(error);
    }
  };
  return null;
};
